import { FC, useEffect, useState } from 'react';
import {
  useBreadcrumbRoutes,
  Wrapper,
  Form,
  FormTitle,
  Button,
  Modal,
  InputNumber,
  message,
} from '@maxtropy/components';
import { Space } from 'antd';
import { apiV2CacheGetPost, apiV2CacheSavePost } from '@maxtropy/cc-customer-apis-v2';

const OverTime: FC = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [form] = Form.useForm();

  useEffect(() => {
    apiV2CacheGetPost({ cacheKey: 'AccountLockTime' }).then(res => {
      if (res.cacheValue) {
        const data = JSON.parse(res.cacheValue);
        form.setFieldsValue({
          ...data,
        });
      }
    });
  }, []);

  const apply = () => {
    let seconds = 3;
    const modal = Modal.confirm({
      title: '确认应用超时登录设定',
      content: `执行相关配置后将会应用到平台内所有用户账号，是否确定？`,
      okText: `确定(${seconds}秒)`,
      okButtonProps: {
        disabled: true,
      },
      onOk: () => {
        apiV2CacheSavePost({ cacheKey: 'AccountLockTime', cacheValue: JSON.stringify(form.getFieldsValue()) }).then(
          res => {
            setIsEdit(false);
            message.success('应用成功');
          }
        );
      },
    });

    const interval = setInterval(() => {
      seconds -= 1;
      modal.update({
        okText: `确定(${seconds}s)`,
      });
      if (seconds <= 0) {
        clearInterval(interval);
        modal.update({
          okText: '确定',
          okButtonProps: { disabled: false },
        });
      }
    }, 1000);
  };

  return (
    <Wrapper routes={breadcrumbRoutes?.routes} className="page_wrapper">
      <FormTitle title="超时登录设定" />
      <div style={{ marginLeft: 32 }}>
        <Form form={form} disabled={!isEdit}>
          <Form.Item label="超时登录时长限制" name="limitTime">
            <InputNumber placeholder="请输入超时登录时长" max={9999} addonAfter={'分钟'} style={{ width: 400 }} />
          </Form.Item>
        </Form>
        <div style={{ marginTop: 32 }}>
          {isEdit ? (
            <Space>
              <Button type="primary" onClick={apply}>
                应用
              </Button>
              <Button onClick={() => setIsEdit(false)}>取消</Button>
            </Space>
          ) : (
            <Button type="primary" onClick={() => setIsEdit(true)}>
              编辑
            </Button>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default OverTime;
